{
  "hero_title": "Alege vehiculul potrivit pentru tine!",
  "hero_subtitle": "Anunțuri de la dealeri și persoane fizice",
  "all_vehicles": "Toate vehiculele",
  "available": "Vehicule disponibile",
  "find_perfect": "Găsește vehiculul perfect pentru tine",
  "verified": "Anunțuri de la dealeri și persoane fizice",
  "select_category": "Selectează categorie vehicul",
  "search_placeholder": "Caută mașini, camioane, motociclete...",
  "no_results": "Nu s-au găsit rezultate",
  "loading": "Se încarcă...",
  "load_more": "Încarcă mai multe",
  "view_details": "Vezi detalii",
  "quick_view": "Vizualizare rapidă",
  "compare": "Compară",
  "results_count": "rezultate",
  "sort_by": "Sortează după",
  "filter": "Filtrează",
  "clear_filters": "Șterge filtre",
  "apply_filters": "Aplică filtre",
  "marketplace_title": "Vehicule de vânzare în România",
  "marketplace_desc": "Vezi anunțurile disponibile și compară prețurile. Contactează direct vânzătorul.",
  "cars_title": "Autoturisme de vânzare în România",
  "cars_desc": "Vezi mașinile disponibile și cere vânzătorului istoricul înainte de cumpărare.",
  "trucks_title": "Camioane de vânzare în România",
  "trucks_desc": "Compară anunțurile pentru camioane și discută direct cu vânzătorul.",
  "motorcycles_title": "Motociclete de vânzare în România",
  "motorcycles_desc": "Vezi motocicletele și scuterele disponibile.",
  "equipment_title": "Utilaje de vânzare în România",
  "equipment_desc": "Vezi utilajele disponibile și cere detalii despre starea lor.",
  "boats_title": "Ambarcațiuni de vânzare în România",
  "boats_desc": "Vezi ambarcațiunile disponibile și contactează vânzătorul.",
  "verified_updated": "Anunțuri disponibile",
  "listings": "anunțuri",
  "list_vehicle": "Listează vehicul",
  "become_dealer": "Devino dealer",
  "subscription_required": "Abonament necesar",
  "subscription_message": "Pentru a lista vehicule ai nevoie de un abonament activ.",
  "login_required": "Autentificare necesară",
  "login_message": "Trebuie să te autentifici pentru a lista vehicule.",
  "my_alerts": "Alertele mele",
  "vehicle_types": "Tipuri de vehicule",
  "popular_brands": "Mărci populare",
  "see_all": "Vezi toate",
  "view_all": "Vezi toate vehiculele",
  "contact_dealer": "Contactează dealerul",
  "save_search": "Salvează căutarea",
  "price_alert": "Alertă preț",
  "page_title": "Vehicule second hand de vânzare | RO Auto Market",
  "meta_description": "Vehicule second hand de la dealeri și persoane fizice. Compară anunțurile și contactează direct vânzătorul.",
  "meta_description_with_count": "{count} de anunțuri de la dealeri și persoane fizice. Compară vehiculele și contactează direct vânzătorul.",
  "cars_popular_brands": "Mărci populare",
  "cars_other_brands": "Alte mărci populare:",
  "cars_search_by_city": "🏙️ Caută mașini după oraș:",
  "cars_not_found": "🚗 Nu găsești ce cauți?",
  "cars_list_help": "Listează vehiculul tău și ajută alți cumpărători",
  "cars_add_listing": "📝 Adaugă anunțul tău",
  "cars_view_plans": "💰 Vezi planurile",
  "cars_no_results": "Nu s-au găsit rezultate pentru filtrele selectate.",
  "cars_reset_filters": "Resetează filtrele",
  "cars_contact_help": "Contactează-ne pentru ajutor",
  "cars_no_listings": "Nu sunt încă anunțuri disponibile pe platformă.",
  "cars_list_first": "Listează prima mașină",
  "cars_back_home": "Înapoi la pagina principală",
  "motorcycles_page_title": "Vânzări motociclete 2025 | Sport, touring, scutere România",
  "motorcycles_page_desc": "Motociclete second hand România: Honda, Yamaha, BMW, Kawasaki. Sport, touring, scutere, ATV. Istoric complet, dealeri autorizați, vânzări verificate.",
  "motorcycles_page_h1": "Vânzări motociclete și scutere România",
  "motorcycles_page_subtitle": "Vânzări motociclete sport, touring și adventure • Istoric complet • Dealeri specializați",
  "motorcycles_page_subtitle2": "De la scutere urbane la motociclete de performanță - găsește pasiunea ta pe două roți. Vânzări motociclete în toată România.",
  "motorcycles_cta_search": "Caută motociclete",
  "motorcycles_cta_list": "Listează motocicleta ta GRATUIT",
  "motorcycles_badge": "Motociclete verificate disponibile",
  "motorcycles_stat1": "Istoric verificat",
  "motorcycles_stat2": "Taxe ascunse",
  "motorcycles_stat3": "Pasionați dedicați",
  "motorcycles_types_title": "Tipuri de motociclete disponibile",
  "motorcycles_type_sport": "Sport",
  "motorcycles_type_sport_desc": "Motociclete de performanță",
  "motorcycles_type_touring": "Touring",
  "motorcycles_type_touring_desc": "Pentru călătorii lungi",
  "motorcycles_type_racing": "Racing",
  "motorcycles_type_racing_desc": "Motociclete de pistă",
  "motorcycles_type_scooters": "Scutere",
  "motorcycles_type_scooters_desc": "Transport urban economic",
  "motorcycles_type_adventure": "Adventure",
  "motorcycles_type_adventure_desc": "Off-road & aventură",
  "motorcycles_type_atv": "ATV",
  "motorcycles_type_atv_desc": "Vehicule all-terrain",
  "motorcycles_why_title": "De ce să alegi motocicletele noastre?",
  "motorcycles_why_tech": "Verificare tehnică",
  "motorcycles_why_tech_desc": "Motor, transmisie, frâne și suspensie verificate de mecanici specializați",
  "motorcycles_why_dealers": "Dealeri pasionați",
  "motorcycles_why_dealers_desc": "Doar dealeri cu experiență în motociclete care înțeleg nevoile motocicliștilor",
  "motorcycles_why_history": "Istoric Complet",
  "motorcycles_why_history_desc": "Întreținere, modificări, accidente - toate detaliile pentru o decizie informată",
  "motorcycles_brands_title": "Mărci populare de motociclete",
  "motorcycles_available": "Motociclete Disponibile",
  "motorcycles_empty": "Încă nu sunt motociclete listate. Verifică în curând!",
  "motorcycles_view_all": "Vezi toate motocicletele",
  "motorcycles_seo_h2_1": "Motociclete second hand de încredere",
  "motorcycles_seo_p1": "Descoperă motociclete second hand verificate pe RO Auto Market. Fie că ești în căutarea unei motociclete sport pentru adrenalină sau a unui scuter economic pentru oraș, avem selecția perfectă.",
  "motorcycles_seo_p2": "Toate motocicletele și scuterele de pe platforma noastră sunt verificate tehnic de specialiști care înțeleg particularitățile fiecărui tip de vehicul pe două roți.",
  "motorcycles_seo_li1": "Motociclete cu istoric complet de întreținere",
  "motorcycles_seo_li2": "Verificare motor și transmisie",
  "motorcycles_seo_li3": "Testare frâne și suspensie",
  "motorcycles_seo_li4": "Documentație și asigurare la zi",
  "motorcycles_seo_h2_2": "Pentru pasionații de două roți",
  "motorcycles_seo_p3": "Înțelegem că pentru un motociclist, vehiculul nu este doar un mijloc de transport. De aceea fiecare motocicletă verificată vine cu detalii complete despre modificări, îmbunătățiri și întreținere.",
  "motorcycles_seo_p4": "De la motociclete touring pentru călătorii lungi la ATV-uri pentru aventuri off-road - pasiunea ta ghidează selecția noastră.",
  "motorcycles_promo_title": "Testează gratuit!",
  "motorcycles_promo_desc": "Testează platforma fără costuri și vezi cât de ușor este să găsești motocicleta perfectă.",
  "motorcycles_cta_final_title": "Găsește motocicleta perfectă astăzi",
  "motorcycles_cta_final_desc": "Motociclete verificate te așteaptă. Începe aventura acum!",
  "motorcycles_cta_final_btn1": "Vezi toate motocicletele",
  "motorcycles_cta_final_btn2": "Vorbește cu un pasionat",
  "compare_banner_title": "🚀 Compară vehicule side-by-side",
  "compare_banner_step1": "Apasă butonul",
  "compare_banner_step1_suffix": "din colțul cardurilor",
  "compare_banner_step2": "Selectează 2-4 vehicule pentru comparare",
  "compare_banner_step3": "Vezi specificațiile comparate în detaliu",
  "compare_banner_close": "Închide",
  "badge_verified_vehicle": "✓ Vehicul de la dealer verificat",
  "badge_history_available": "📜 Istoric Disponibil",
  "badge_verified_dealer": "🛡️ Dealer Verificat",
  "description": "Descriere",
  "interested_title": "Interesat de acest vehicul?",
  "call_directly": "Sună direct",
  "contact_dealer": "Contactează dealerul",
  "request_offer": "Cere ofertă",
  "reserve_24h": "Rezervă 24h",
  "key_specs": "Aspecte importante",
  "spec_mileage": "Kilometraj",
  "spec_fuel": "Combustibil",
  "spec_transmission": "Transmisie",
  "spec_year": "An",
  "spec_location": "Locație",
  "spec_condition": "Stare",
  "price_history_title": "Istoric prețuri",
  "price_history_desc": "Transparență totală - vezi cum a evoluat prețul în timp",
  "price_current": "Preț actual",
  "price_lowest": "Cel mai mic",
  "price_highest": "Cel mai mare",
  "price_trend": "Trend",
  "trend_decreasing": "în scădere",
  "trend_increasing": "în creștere",
  "trend_stable": "stabil",
  "price_reduced": "Preț redus cu {amount}€!",
  "price_save": "Economisești {percentage}% față de prețul inițial",
  "price_history_changes": "Istoric Modificări ({count})",
  "price_history_start": "Start",
  "carvertical_title": "Verifică istoricul vehicului",
  "carvertical_subtitle": "Obține raport detaliat despre accidente, kilometraj real, status legal și multe altele",
  "carvertical_recommended_title": "Verificare recomandată a istoricului",
  "carvertical_partner_badge": "Partener Recomandat",
  "carvertical_description": "ROAutoMarket recomandă CarVertical România pentru verificări independente ale istoricului vehiculelor. Pentru verificare completă, vei avea nevoie de VIN-ul mașinii - o informație pe care vânzătorul o poate furniza.",
  "carvertical_accident_history": "Istoric accidente",
  "carvertical_real_mileage": "Kilometraj real",
  "carvertical_service_history": "Istoric service",
  "carvertical_technical_checks": "Verificări tehnice",
  "carvertical_tip_title": "💡 Sfat pentru cumpărători",
  "carvertical_tip_description": "Contactează vânzătorul pentru VIN-ul mașinii înainte de verificare. CarVertical este un serviciu independent - costul (1-3€) se plătește direct către ei, nu către ROAutoMarket sau vânzător.",
  "carvertical_button_full": "Accesează CarVertical România",
  "carvertical_button_short": "Verifică CarVertical",
  "carvertical_vin_available": "VIN disponibil:",
  "carvertical_toast_title": "Serviciu recomandat de ROAutoMarket",
  "carvertical_toast_desc": "Te-am redirecționat către CarVertical România - un serviciu independent de verificare a istoricului auto.",
  "equipment_page_title": "Vânzări tractoare și utilaje 2025 | Excavatoare, buldozere România",
  "equipment_page_desc": "Utilaje second hand România: Caterpillar, Komatsu, JCB, Volvo. Tractoare, excavatoare, buldozere. Verificare tehnică, dealeri specializați.",
  "equipment_page_h1": "Vânzări tractoare și utilaje România",
  "equipment_page_subtitle": "Vânzări utilaje agricole și construcții • Istoric complet • Dealeri specializați",
  "equipment_page_subtitle2": "De la tractoare agricole la excavatoare industriale - utilajul perfect pentru proiectele tale. Vânzări utilaje în toată România.",
  "equipment_cta_search": "Caută utilaje",
  "equipment_cta_list": "Listează utilajul tău GRATUIT",
  "equipment_badge": "Utilaje verificate disponibile",
  "equipment_stat1": "Verificare tehnică",
  "equipment_stat2": "Surprize neplăcute",
  "equipment_stat3": "Experți disponibili",
  "equipment_types_title": "Tipuri de utilaje disponibile",
  "equipment_type_tractors": "Tractoare agricole",
  "equipment_type_tractors_desc": "Pentru lucrări agricole",
  "equipment_type_excavators": "Excavatoare",
  "equipment_type_excavators_desc": "Săpături și demol��ri",
  "equipment_type_bulldozers": "Buldozere",
  "equipment_type_bulldozers_desc": "Lucrări de terasament",
  "equipment_type_cranes": "Macarale",
  "equipment_type_cranes_desc": "Ridicare și manipulare",
  "equipment_type_loaders": "Încărcătoare",
  "equipment_type_loaders_desc": "Deplasare materiale",
  "equipment_type_road": "Utilaje rutiere",
  "equipment_type_road_desc": "Asfaltare și compactare",
  "equipment_why_title": "De ce să alegi utilajele noastre?",
  "equipment_why_industrial": "Verificare industrială",
  "equipment_why_industrial_desc": "Testare completă: motor, hidraulică, sisteme de comandă și componente de uzură",
  "equipment_why_specialists": "Specialiști certificați",
  "equipment_why_specialists_desc": "Dealeri cu experiență în utilaje industriale și agricole",
  "equipment_why_detailed": "Istoric Detaliat",
  "equipment_why_detailed_desc": "Ore de funcționare, întreținere, reparații și toate modificările efectuate",
  "equipment_brands_title": "Mărci populare de utilaje",
  "equipment_available": "Utilaje Disponibile",
  "equipment_empty": "Încă nu sunt utilaje listate. Verifică în curând!",
  "equipment_view_all": "Vezi toate utilajele",
  "equipment_seo_h2_1": "Utilaje second hand de încredere",
  "equipment_seo_p1": "Găsește utilajul second hand perfect pentru proiectele tale pe RO Auto Market. Oferim o gamă completă de utilaje verificate pentru agricultură, construcții și industrie.",
  "equipment_seo_p2": "Toate utilajele agricole și de construcții sunt verificate de specialiști cu experiență în echipamente industriale, asigurând performanță și fiabilitate.",
  "equipment_seo_li1": "Verificare completă: motor, hidraulică, sisteme",
  "equipment_seo_li2": "Testare în condiții reale de lucru",
  "equipment_seo_li3": "Documentație tehnică și de întreținere",
  "equipment_seo_li4": "Suport pentru transport și instalare",
  "equipment_seo_h2_2": "Pentru profesioniști pretențioși",
  "equipment_seo_p3": "Înțelegem că în construcții și agricultură fiecare oră de nefuncționare costă. De aceea toate utilajele noastre sunt gata de folosire imediată.",
  "equipment_seo_p4": "De la tractoare agricole pentru fermieri la excavatoare pentru antreprenori - avem utilajul potrivit pentru fiecare domeniu.",
  "equipment_promo_title": "Testează gratuit!",
  "equipment_promo_desc": "Testează platforma și vezi cât de simplu este să găsești utilajul perfect.",
  "equipment_cta_final_title": "Găsește utilajul perfect astăzi",
  "equipment_cta_final_desc": "Utilaje verificate pentru toate nevoile tale. Începe căutarea acum!",
  "equipment_cta_final_btn1": "Vezi toate utilajele",
  "equipment_cta_final_btn2": "Vorbește cu un specialist",
  "boats_page_title": "Vânzări bărci și ambarcațiuni 2025 | Yachturi, bărci cu motor România",
  "boats_page_desc": "Bărci și ambarcațiuni second hand România: Sea Ray, Bayliner, Princess. Verificare nautică, dealeri specializați. Vânzări ambarcațiuni verificate.",
  "boats_page_h1": "Vânzări bărci și ambarcațiuni România",
  "boats_page_subtitle": "Vânzări bărci și yachturi verificate • Istoric nautic complet • Dealeri specializați",
  "boats_page_subtitle2": "De la bărci de pescuit la yachturi de lux - găsește aventura ta pe apă cu încredere. Vânzări ambarcațiuni în toată România.",
  "boats_cta_search": "Caută ambarcațiuni",
  "boats_cta_list": "Listează ambarcațiunea ta GRATUIT",
  "boats_badge": "Ambarcațiuni verificate disponibile",
  "boats_stat1": "Verificare nautică",
  "boats_stat2": "Probleme ascunse",
  "boats_stat3": "Experți nautici",
  "boats_types_title": "Tipuri de ambarcațiuni disponibile",
  "boats_type_fishing": "Bărci de pescuit",
  "boats_type_fishing_desc": "Pentru pescuit sportiv și recreativ",
  "boats_type_motor": "Bărci cu motor",
  "boats_type_motor_desc": "Plimbări și transport rapid",
  "boats_type_yachts": "Yachturi",
  "boats_type_yachts_desc": "Lux și confort pe apă",
  "boats_type_sport": "Bărci sportive",
  "boats_type_sport_desc": "Sporturi nautice și aventură",
  "boats_type_speed": "Bărci de viteză",
  "boats_type_speed_desc": "Viteză și performanță",
  "boats_type_small": "Ambarcațiuni mici",
  "boats_type_small_desc": "Canoe, kayak-uri, bărci gonflabile",
  "boats_why_title": "De ce să alegi ambarcațiunile noastre?",
  "boats_why_nautical": "Verificare nautică",
  "boats_why_nautical_desc": "Cocă, motor, sisteme electrice și echipament de siguranță verificate complet",
  "boats_why_experts": "Experți nautici",
  "boats_why_experts_desc": "Dealeri cu experiență în ambarcațiuni care înțeleg specificul vieții pe apă",
  "boats_why_maritime": "Istoric Maritim",
  "boats_why_maritime_desc": "Întreținere, reparații, îmbunătățiri și toate detaliile pentru o decizie informată",
  "boats_brands_title": "Mărci populare de ambarcațiuni",
  "boats_available": "Ambarcațiuni disponibile",
  "boats_empty": "Încă nu sunt ambarcațiuni listate. Verifică în curând!",
  "boats_view_all": "Vezi toate ambarcațiunile",
  "boats_seo_h2_1": "Ambarcațiuni second hand de calitate",
  "boats_seo_p1": "Descoperă ambarcațiuni second hand verificate pe RO Auto Market. De la bărci de pescuit pentru relaxare la yachturi de lux pentru experiențe memorabile.",
  "boats_seo_p2": "Toate bărcile și yachturile din selecția noastră sunt verificate de experți nautici care cunosc particularitățile vieții pe apă și specificul fiecărui tip de ambarcațiune.",
  "boats_seo_li1": "Verificare completă: cocă, motor, sisteme",
  "boats_seo_li2": "Testare echipament de siguranță",
  "boats_seo_li3": "Documentație nautică completă",
  "boats_seo_li4": "Suport pentru transport și andocare",
  "boats_seo_h2_2": "Pentru pasionații de apă",
  "boats_seo_p3": "Înțelegem că pentru un iubitor de apă, o ambarcațiune reprezintă libertate și aventură. Fiecare ambarcațiune verificată vine cu detalii complete despre istoricul de întreținere și utilizare.",
  "boats_seo_p4": "De la bărci de pescuit pentru pasionații de pescuit la yachturi de lux pentru cei care caută confort și eleganță pe apă.",
  "boats_promo_title": "Testează gratuit!",
  "boats_promo_desc": "Testează platforma fără costuri și navighează către ambarcațiunea perfectă.",
  "boats_cta_final_title": "Găsește ambarcațiunea perfectă astăzi",
  "boats_cta_final_desc": "Ambarcațiuni verificate te așteaptă. Începe aventura ta pe apă acum!",
  "boats_cta_final_btn1": "Vezi toate ambarcațiunile",
  "boats_cta_final_btn2": "Vorbește cu un expert nautic",
  "loading_more": "Se încarcă mai multe vehicule...",
  "end_of_list": "Ai ajuns la finalul listei",
  "vehicles_displayed": "vehicule afișate",
  "no_results_title": "Nu s-au găsit rezultate",
  "no_results_desc": "Nu am găsit vehicule care să corespundă criteriilor tale. Încearcă să modifici filtrele sau contactează-ne pentru ajutor.",
  "how_it_works": "Cum funcționează",
  "contact_us": "Contactează-ne",
  "back_home": "Înapoi la pagina principală",
  "read_more": "Vezi mai mult",
  "read_less": "Vezi mai puțin",
  "vehicle_history_check_title": "Verifică istoricul vehiculului",
  "vehicle_history_check_desc": "Obține raport detaliat despre accidente, kilometraj real, status legal și multe altele",
  "additional_info_title": "Informații suplimentare",
  "owner_count": "Număr proprietari",
  "owner_singular": "proprietar",
  "owner_plural": "proprietari",
  "service_history": "Istoric Service",
  "service_history_complete": "Istoric complet service la dealer autorizat",
  "warranty": "Garanție",
  "warranty_months": "{months} luni garanție inclusă",
  "environmental_badge": "Normă de poluare",
  "first_registration": "Prima înmatriculare",
  "equipment_included": "Dotări incluse",
  "service_complete_verified": "Complet și verificat",
  "steering_wheel": "Volan",
  "rhd_text": "Pe dreapta (RHD)",
  "lhd_text": "Pe stânga (LHD)",
  "mot_valid_until": "MOT valid până la",
  "ulez_compliant": "ULEZ Compliant",
  "ulez_yes": "Da - Conform ULEZ Londra",
  "ulez_no": "Nu - Nu îndeplinește ULEZ",
  "equipment_features": "Echipamente și dotări",
  "year_label": "An",
  "location_label": "Locație",
  "condition_label": "Stare",
  "fuel_label": "Combustibil",
  "transmission_label": "Transmisie",
  "price_negotiable": "Preț negociabil",
  "no_image": "Fără poză disponibilă",
  "contact_dealer_button": "Contactează dealerul",
  "send_message": "Trimite mesaj",
  "send_message_dealer": "Trimite mesaj dealer",
  "back": "Înapoi",
  "view_full_details": "Vezi detalii complete",
  "year_manufacture": "An fabricație",
  "engine_power": "Putere motor",
  "operating_hours": "Ore motor",
  "hours": "ore",
  "boat_tech_specs": "Specificații tehnice ambarcațiune",
  "length": "Lungime",
  "meters": "metri",
  "type": "Tip",
  "hull": "Carenă",
  "power": "Putere",
  "mileage": "Kilometraj",
  "no_type_available": "Momentan nu avem {type} disponibile",
  "view_all_categories": "Vezi toate categoriile",
  "seo_title": "Toate tipurile de vehicule România",
  "seo_intro": "Pe RO Auto Market vezi anunțuri de la dealeri și persoane fizice. Folosește filtrele pentru a găsi un vehicul disponibil.",
  "seo_dealer": "Contactează direct vânzătorul. Cere istoricul și actele vehiculului înainte de a lua o decizie.",
  "seo_brands": "Compară prețurile și detaliile anunțurilor active. Verifică vehiculul în persoană înainte de cumpărare.",
  "platform_title": "Platforma completă pentru orice vehicul",
  "machinery_title": "🚜 Utilaje & Tractoare",
  "machinery_desc": "Utilaje agricole, excavatoare, buldozere - Caterpillar, Komatsu, JCB. Pentru fermieri și contractori.",
  "vans_title": "Autoutilitare",
  "trailers_title": "Remorci",
  "agricultural_title": "Utilaje Agricole",
  "construction_title": "Utilaje construcții",
  "atv_title": "ATV/UTV",
  "results_found": "rezultate găsite"
}
